import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import type { LangKey } from '../data/translations';
const navItems = [{
  key: 'nav.about',
  href: '#about'
}, {
  key: 'nav.services',
  href: '#services'
}, {
  key: 'nav.experience',
  href: '#experience'
}, {
  key: 'nav.approach',
  href: '#approach'
}, {
  key: 'nav.advantages',
  href: '#advantages'
}, {
  key: 'nav.faq',
  href: '#faq'
}, {
  key: 'nav.contact',
  href: '#contact'
}];
const languages: LangKey[] = ['ru', 'kz', 'en'];
export function Header() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = () => setMobileOpen(false);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-graphite/95 backdrop-blur-md border-b border-slate-800/50' : 'bg-transparent'}`} data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-223">
          {/* Logo */}
          <a href="#" className="flex items-center gap-1 shrink-0" data-id="element-224">
            <span className="text-sm sm:text-base font-bold tracking-[0.2em] uppercase text-slate-100" data-id="element-225">
              Power <span className="text-electric" data-id="element-226">Logic</span> Automation
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" aria-label="Main navigation" data-id="element-227">
            {navItems.map(item => <a key={item.key} href={item.href} className="px-3 py-2 text-xs font-medium uppercase tracking-wider text-slate-400 hover:text-electric transition-colors duration-200" data-id="element-228">
                {t(item.key)}
              </a>)}
          </nav>

          {/* Language Switcher + Mobile Toggle */}
          <div className="flex items-center gap-3" data-id="element-229">
            <div className="flex items-center bg-navy/60 rounded border border-slate-700/50" data-id="element-230">
              {languages.map(l => <button key={l} onClick={() => setLang(l)} className={`px-2.5 py-1.5 text-xs font-semibold uppercase tracking-wider transition-all duration-200 ${lang === l ? 'bg-electric text-white rounded' : 'text-slate-500 hover:text-slate-300'}`} aria-label={`Switch language to ${l.toUpperCase()}`} aria-pressed={lang === l} data-id="element-231">
                  {l}
                </button>)}
            </div>

            <button className="lg:hidden p-2 text-slate-400 hover:text-white transition-colors" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} data-id="element-232">
              {mobileOpen ? <XIcon className="w-5 h-5" data-id="element-233" /> : <MenuIcon className="w-5 h-5" data-id="element-234" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${mobileOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-235">
        <nav className="bg-graphite/98 backdrop-blur-md border-t border-slate-800/50 px-4 py-4 space-y-1" aria-label="Mobile navigation" data-id="element-236">
          {navItems.map(item => <a key={item.key} href={item.href} onClick={handleNavClick} className="block px-4 py-3 text-sm font-medium uppercase tracking-wider text-slate-400 hover:text-electric hover:bg-navy/40 rounded transition-colors duration-200" data-id="element-237">
              {t(item.key)}
            </a>)}
        </nav>
      </div>
    </header>;
}